import { createAsyncThunk } from '@reduxjs/toolkit'

import Query from 'redux/PrepareQuery'
import type { RootState } from 'redux/store/RootReducer'
import type { AppDispatch } from 'redux/store'
import homePageAPI from 'api/ApiActions/HomePage/HomePage'

export const fetchHomePageRevision: any = createAsyncThunk<
  any,
  any,
  {
    dispatch: AppDispatch
    state: RootState
  }
>(
  'homePageRevision/fetchHomePageRevision',
  async (_obj, { rejectWithValue }) => {
    const queries = {
      page: 1,
      per_page: 1,
    }

    const filters = {
      sort: {
        id: 'desc',
      },
      published: true,
    }

    const query = new Query(queries, filters)

    try {
      const response = await homePageAPI.getHomePageRevisions(query)

      return response.data.data[0]
    } catch (error) {
      return rejectWithValue(error)
    }
  },
)
